var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5352 53.0334V83.368",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7988 83.368V53.0334",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2012 7.53174H92.4688",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8672 7.53174H62.1348",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7324 7.53174H31.7992",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53125 7.53174H18.8961",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7988 13.5979H7.53125",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4689 13.5979H68.1992",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1328 13.5979H37.8652",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.207 83.3679H98.5352V90.5152C98.5352 91.5939 97.6607 92.4683 96.582 92.4683H3.41797C2.33926 92.4683 1.46484 91.5939 1.46484 90.5152V83.3679H19.3711",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46484 83.3681V8.5083C1.46484 7.96904 1.90215 7.53174 2.44141 7.53174H7.53164V83.3679",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7988 22.6991V7.53174H37.8658V22.6991",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1328 22.6991V7.53174H68.1998V22.6991",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4688 22.6991V7.53174H97.559C98.0982 7.53174 98.5355 7.96904 98.5355 8.5083V22.6989",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5416 22.699H98.5348V53.0334H31.7988V22.699H80.7057",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8672,
    cy: 28.7659,
    r: 1.46484,
    fill: "#012060"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.168,
    cy: 28.7659,
    r: 1.46484,
    fill: "#012060"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4688,
    cy: 28.7659,
    r: 1.46484,
    fill: "#012060"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8672,
    cy: 46.9666,
    r: 1.46484,
    fill: "#012060"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.168,
    cy: 46.9666,
    r: 1.46484,
    fill: "#012060"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4688,
    cy: 46.9666,
    r: 1.46484,
    fill: "#012060"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8672,
    cy: 59.1003,
    r: 1.46484,
    fill: "#012060"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.168,
    cy: 59.1003,
    r: 1.46484,
    fill: "#012060"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4688,
    cy: 59.1003,
    r: 1.46484,
    fill: "#012060"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8672,
    cy: 77.301,
    r: 1.46484,
    fill: "#012060"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.168,
    cy: 77.301,
    r: 1.46484,
    fill: "#012060"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4688,
    cy: 77.301,
    r: 1.46484,
    fill: "#012060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.11042e1063895aabce92b694135fd41f.svg";
export { ForwardRef as ReactComponent };